'use strict';
const angular = require('angular');
const {isDefined} = angular;

var editTemplate = require('./builder-edit.html');
var viewTemplate = require('./builder-view.html');

module.exports.directive = [
  'TransformerDirectiveFactory',
  FormFieldBuilderDirective];

module.exports.controller = [
  '$scope',
  'HashMap',
  'FormUtils',
  'TransformerMixin',
  '$popup',
  FormFieldBuilderController];

module.exports.templates = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('forms/builder-edit.html', editTemplate);
  $templateCache.put('forms/builder-view.html', viewTemplate);
}

//TODO(i18n): setup translation codes
var types = [
  {value: 'text_short', label: 'Text'},
  {value: 'text_long', label: 'Paragraph'},
  {value: 'date', label: 'Date'},
  {value: 'duration', label: 'Duration'},
  {value: 'scale', label: 'Range'},
  {value: 'list', label: 'List'}/*,
   {value: 'location', label: 'Location'},
   {value: 'file', label: 'File Attachment'},
   {value: 'reference_link', label: 'Linked Info'}*/
];

function FormFieldBuilderDirective(TransformerDirectiveFactory) {
  var transformConfig = {
    controllerAs: 'formFieldBuilder',
    bindToController: true,
    modes: [
      {name: 'builder-edit', templateUrl: 'forms/builder-edit.html', defaultMode: true},
      {name: 'builder-view', templateUrl: 'forms/builder-view.html'}
    ]
  };

  return {
    restrict: 'E',
    template: '',
    scope: {
      currentMode: '=?',
      api: '=?fieldApi',
      builderApi: '=?',
      model: '='
    },
    controllerAs: 'formFieldBuilder',
    bindToController: true,
    compile: TransformerDirectiveFactory(transformConfig),
    controller: 'FormFieldBuilderController'
  };
}

function FormFieldBuilderController($scope, HashMap, FormUtils, TransformerMixin, $popup) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/
  var vm = this;
  var fieldOptionsCache = new HashMap();
  vm.types = Object.create(types);
  vm.typeData = {};
  vm.api = vm.api || {};

  vm.toggleEditMode = toggleEditMode;
  vm.deleteField = deleteField;

  var transformer = TransformerMixin($scope, vm);

  // Define API
  Object.defineProperties(vm.api, {
    getMode: {enumerable: true, value: getMode},
    setMode: {enumerable: true, value: setMode}
  });

  $scope.$watch(function () {
    return vm.model && vm.model.type;
  }, function (newValue, oldValue) {
    if (newValue && (newValue !== oldValue)) {
      vm.model.options = updateFieldOptions(newValue, oldValue, vm.model.options);
    }

    if (!vm.label || (newValue && (newValue !== oldValue))) {
      vm.label = getLabel(newValue);
    }
  });

  function deleteField() {
    if (vm.builderApi) {
      if (!vm.builderApi.isFieldPersisted(vm.model)) {
        vm.builderApi.removeField(vm.model);
      } else {
        return $popup.checkboxConfirm({
          cssClass: 'delete-field-popup',
          body: 'Are you sure you want to delete this field?<br/>Deleting it means that it will no longer be available in new uses of this form. This action cannot be undone.<br/><br/>',
          optionLabel: 'Also remove field from existing responses.',
          okayLabel: 'default.delete.confirm.label',
          cancelLabel: 'default.no.label'
        }).then(function (response) {
          if (response) {
            if (response.option) {
              vm.builderApi.removeField(vm.model);
            } else {
              vm.model.legacy = true;
            }
          }
        });
      }
    } else {
      console.warn('builder api not found!')
    }

    return Promise.resolve(null);
  }

  function getLabel(type) {
    var i = types.length;

    while (i--) {
      if (types[i].value === type) {
        return types[i].label;
      }
    }
  }

  function updateFieldOptions(newFieldType, oldFieldType, previousOptions) {
    if (!newFieldType) {
      throw new Error('no field type selected!');
    } else {
      if (oldFieldType) {
        fieldOptionsCache.put(oldFieldType, previousOptions);
      }

      var selectedOptions = fieldOptionsCache.get(newFieldType);
      if (!selectedOptions) {
        selectedOptions = FormUtils.generateOptions(newFieldType);
        fieldOptionsCache.put(newFieldType, selectedOptions);
      }

      return selectedOptions;
    }
  }

  function updateTypeData() {
    if (!vm.model || !vm.typeData) return;
    switch (vm.model.type) {
      case 'list':
        cleanupItems();
        break;
      case 'reference_link':
        if (vm.typeData.references) {
          applyReferencesToOptions(vm.typeData.references);
        }
        break;
    }
  }


  /*****************************************************************************************************************
   * list specific functionality
   ****************************************************************************************************************/

  function cleanupItems() {
    var i = vm.model.options.items.length;
    while (i--) {
      if (vm.model.options.items[i].label === '') {
        if (i === vm.model.options.items.length - 1) {
          vm.model.options.items.pop();
        } else {
          vm.model.options.items.splice(i, 1);
        }
      }
    }
  }

  /*****************************************************************************************************************
   * reference_link specific functionality
   ****************************************************************************************************************/

  function applyReferencesToOptions(references) {
    if (!references) return;
    vm.model.options.domainCollections = [];

    var i = references.length;
    while (i--) {
      if (references[i].value) {
        vm.model.options.domainCollections.push({
          collection: references[i].collection
        });
      }
    }
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function getMode() {
    return vm.currentMode;
  }

  function setMode(mode) {
    if (isDefined(mode) && (mode === 'builder-edit' || mode === 'builder-view')) {
      transformer.changeMode(mode);
    } else {
      throw new Error('Invalid mode passed to FormFieldBuilderController.setMode(). Available options are "builder-edit" and "builder-view". Received: ' + mode);
    }
  }

  // TODO: validate the field before leaving edit mode
  function toggleEditMode() {
    if (vm.currentMode === 'builder-edit') {
      updateTypeData();
      transformer.changeMode('builder-view');
      //console.log('update model', vm.model);
    } else {
      transformer.changeMode('builder-edit');
    }
    $scope.$emit('form-fields:change-mode', {
      field: vm.model,
      mode: vm.currentMode
    })
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}


// WEBPACK FOOTER //
// ./src/js/forms/directives/fields/FormFieldBuilderDirective.js